// extracted by mini-css-extract-plugin
export default {"fullScreenContainer":"RenderLevel_fullScreenContainer__XwxS1","gameScreen":"RenderLevel_gameScreen__LM5c2"};